import { Typography } from '@mui/material';
import { useStyles } from './styles';

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  text: React.ReactNode;
  linkHref?: string;
}

export const SidebarLogo: React.FC<Props> = ({ linkHref, text, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classes.logo} {...rest}>
      {linkHref ? (
        <a href={linkHref} target='_blank' rel='noopener noreferrer' className={classes.logoLink}>
          <Typography color='inherit' component='span' className={classes.logoText}>
            {text}
          </Typography>
        </a>
      ) : (
        <Typography color='inherit' component='span' className={classes.logoText}>
          {text}
        </Typography>
      )}
    </div>
  );
};
